import styled from 'styled-components'
import { GREEN, GREY_LIGHTEST, GREY_MEDIUM, WHITE } from '../../utils/colors'

export const Container = styled.div`
  padding: 40px 32px;
  padding-bottom: 10px;
  border-radius: 10px;
  border: solid 1px ${GREY_LIGHTEST};
  background-color: ${WHITE};

  .flex {
    display: flex;
  }

  .flex_inside {
    flex: 1;
  }

  .buttons {
    text-align: center;
    margin: 0px -4px;
  }

  h3 {
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: ${GREEN};
    margin-bottom: 32px;
  }

  span {
    display: block;
  }

  .label {
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: normal;
    color: ${GREY_MEDIUM};
  }

  .text {
    line-height: 23px;
    min-height: 23px;
    margin-bottom: 22px;
    font-size: 14px;
    font-weight: bold;
    color: ${GREEN};
  }
`
